{% block sw_cms_element_acris_blog_image_slider_preview %}
    <div class="sw-cms-el-preview-acris-blog-image-slider">
        <mt-icon
                name="regular-chevron-left"
                size="10"
        />
        <div>
            <img
                    :src="assetFilter('/administration/administration/static/img/cms/preview_mountain_small.jpg')"
                    alt=""
            >
        </div>
        <mt-icon
                name="regular-chevron-right"
                size="10"
        />
    </div>
{% endblock %}
